import { Tooltip } from '../../../../ui/components/pure/tooltip/tooltip';
import { Colors } from '../../../../ui/theme/colors';
import {
  CourierCapabilityGrants,
  MAX_CAPABILITY_ICONS,
  makeCourierCapabilityIcons
} from '../logic/courier-capabilities.map';

const ICON_SIZE = '24px';

export function CourierCapabilitiesCell({ grants }: { grants: CourierCapabilityGrants }) {
  const icons = makeCourierCapabilityIcons(grants).slice(0, MAX_CAPABILITY_ICONS);

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
      {icons.map(({ Icon, label, tooltip, isDirect }) => (
        <Tooltip key={label} title={tooltip} placement="bottom" width="auto">
          <span style={{ display: 'inline-flex' }}>
            <Icon
              style={{
                width: ICON_SIZE,
                height: ICON_SIZE,
                color: isDirect ? Colors.extraDarkGray : Colors.timelineGray,
                marginRight: '3px'
              }}
            />
          </span>
        </Tooltip>
      ))}
    </span>
  );
}
